var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-up-log"},[_c('a',{class:{ isNew: _vm.v.isNew },attrs:{"href":_vm.v.link,"target":"blank"},on:{"click":function($event){return _vm.clickHandler()}}},[_vm._v("更新日志")])])}
var staticRenderFns = []

export { render, staticRenderFns }